import * as actionTypes from '../actionTypes';

const initialStore = {
    allCollections: [],
    pagination: {},
    collectionsIsLoading: false,
    userCollections: [],
    userCollectionsPagination: {},
    collection: {},
    collectionPagination: {},
    collectionIsLoading: false,
    collectionIsCreating: false,
    isUploading: false,
    asset: {
        logo: null,
        banner: null,
        feature: null,
    },
    slugIsLoading: false,
    error: ''
};

const reducer = (state = initialStore, {type, payload}) => {
    switch (type) {
        case actionTypes.GET_ALL_COLLECTIONS_START:
            return {
                ...state,
                collectionsIsLoading: true
            };
        case actionTypes.GET_ALL_COLLECTIONS_SUCCESS:
            return {
                ...state,
                allCollections: payload.data,
                pagination: payload.meta.pagination,
                collectionsIsLoading: false,
            }
        case actionTypes.GET_ALL_COLLECTIONS_FAIL:
            return {
                ...state,
                collectionsIsLoading: false,
            };

        case actionTypes.GET_USER_COLLECTIONS_START:
            return {
                ...state,
                collectionsIsLoading: true
            };
        case actionTypes.GET_USER_COLLECTIONS_SUCCESS:
            return {
                ...state,
                userCollections: payload.data,
                userCollectionsPagination: payload.meta.pagination,
                collectionsIsLoading: false
            };
        case actionTypes.GET_USER_COLLECTIONS_FAIL:
            return {
                ...state,
                collectionsIsLoading: false
            };

        case actionTypes.GET_COLLECTION_START:
            return {
                ...state,
                collectionIsLoading: true
            };
        case actionTypes.GET_COLLECTION_SUCCESS:
            return {
                ...state,
                collection: payload.data,
                collectionPagination: payload.data.products.meta.pagination,
                collectionIsLoading: false
            };
        case actionTypes.GET_COLLECTION_FAIL:
            return {
                ...state,
                collectionIsLoading: false,
                error: payload
            };

        case actionTypes.SAVE_COLLECTION_START:
            return {
                ...state,
                collectionIsCreating: true,
            };
        case actionTypes.SAVE_COLLECTION_SUCCESS:
            return {
                ...state,
                collectionIsCreating: false,
            };
        case actionTypes.SAVE_COLLECTION_FAIL:
            return {
                ...state,
                collectionIsCreating: false,
                error: payload
            };

        case actionTypes.UPLOAD_ASSET_START:
            return {
                ...state,
                isUploading: true,
            };
        case actionTypes.UPLOAD_LOGO_SUCCESS:
            return {
                ...state,
                asset: {...state.asset, logo: payload.data.data.origin},
                isUploading: false,
            };
        case actionTypes.UPLOAD_BANNER_SUCCESS:
            return {
                ...state,
                asset: {...state.asset, banner: payload.data.data.origin},
                isUploading: false,
            };
        case actionTypes.UPLOAD_FEATURE_SUCCESS:
            return {
                ...state,
                asset: {...state.asset, feature: payload.data.data.origin},
                isUploading: false,
            };
        case actionTypes.UPLOAD_ASSET_FAIL:
            return {
                ...state,
                isUploading: false,
            };

        case actionTypes.CHECK_URL_START:
            return {
                ...state,
                slugIsLoading: true
            }
        case actionTypes.CHECK_URL_SUCCESS:
            return {
                ...state,
                slugIsLoading: false
            }
        case actionTypes.CHECK_URL_FAIL:
            return {
                ...state,
                slugIsLoading: false
            }

        case actionTypes.DELETE_COLLECTION_START:
            return  {
                ...state,
                collectionsIsLoading: true
            }
        case actionTypes.DELETE_COLLECTION_SUCCESS:
            return  {
                ...state,
                collectionsIsLoading: false
            }
        case actionTypes.DELETE_COLLECTION_FAIL:
            return  {
                ...state,
                collectionsIsLoading: false
            }
        default:
            return state;
    }
};

export default reducer;
